// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"1164":"reg-login","6578":"f857bbdd","7538":"recorder","9983":"profiler"}[chunkId] || chunkId) + "." + {"1164":"a833a8f45d3d8f90","2460":"3ec229dd94e8c6bb","4328":"4d5f9b698acfd3fd","6578":"55184b9ea39b603d","7538":"698db91c7021e786","9983":"f064bc77554376cb"}[chunkId] + ".js";
};